module.exports = __webpack_public_path__ + "static/img/img_w.c413ab94.png";